import InfoTwoTone from '@pf-ui/pf-icons-react/InfoTwoTone';
import * as React from 'react';
const Simple = () => React.createElement(InfoTwoTone, null);
export default Simple;
